import { DateFilter } from "../filters/date-filter";

export const VersionFilters = ({
  overrideDate,
  setOverrideDate,
}: {
  overrideDate: { dateFrom: string; dateTo: string; index: number };
  setOverrideDate: (overrideDate: {
    dateFrom: string;
    dateTo: string;
    index: number;
  }) => void;
}) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between">
      <DateFilter
        overrideDate={overrideDate}
        setOverrideDate={setOverrideDate}
        view="version-details"
      />
    </div>
  );
};
